/**
 * Gratis-Buerste im Cart-Drawer-Footer (Progressive Gift der Upsell-Shark-App).
 * - Trash-Icon (.cart-free-gift__remove): das Entfernen macht der delegierte
 *   .remove-Listener in app.js, hier wird nur gemerkt, dass der Kunde die Buerste
 *   abgewaehlt hat (sessionStorage), damit sie nicht gleich wieder auftaucht.
 * - CTA "Buerste hinzufuegen" (.cart-free-gift__add): Add mit der Gift-Property
 *   aus theme.settings.shark_offer_property_gift, bundle_shark=true damit der
 *   App-Interceptor den Request nicht durch das komplette Bundle ersetzt.
 * - reconcile(): unter 5 Shakern wird eine vorhandene Buerste automatisch aus
 *   dem Cart entfernt (die Discount-Function wuerde sie sonst voll berechnen).
 *   Entfernt wird ueber den item.key (nicht den Line-Index), damit ein
 *   veralteter Zustand nie eine andere Zeile trifft.
 * Der Drawer wird nach jeder Mutation per Section Rendering komplett neu
 * gerendert, deshalb nur delegierte Listener und ein MutationObserver auf dem
 * Drawer, der den versteckten [data-gift-state]-Span aus dem Liquid auswertet.
 * Jeder Render-Stand wird genau einmal ausgewertet (Span-Identitaet).
 */
(function () {
  var DISMISSED_KEY = 'gift-brush-dismissed';
  var inFlight = false;
  var timer = null;
  var lastStateEl = null;
  // Schutz gegen Endlosschleifen, falls ein Auto-Remove serverseitig nicht greift
  var autoRemoveAttempts = 0;
  var MAX_AUTO_REMOVE = 3;

  function isDismissed() {
    try { return sessionStorage.getItem(DISMISSED_KEY) === '1'; } catch (e) { return false; }
  }
  function setDismissed(on) {
    try {
      if (on) sessionStorage.setItem(DISMISSED_KEY, '1');
      else sessionStorage.removeItem(DISMISSED_KEY);
    } catch (e) { /* sessionStorage nicht verfuegbar */ }
  }

  function getDrawer() {
    return document.getElementById('Cart-Drawer');
  }

  function readState() {
    var drawer = getDrawer();
    var el = drawer && drawer.querySelector('[data-gift-state]');
    if (!el) return null;
    return {
      count: parseInt(el.dataset.giftShakerCount, 10) || 0,
      threshold: parseInt(el.dataset.giftThreshold, 10) || 5,
      lineIndex: parseInt(el.dataset.giftLineIndex, 10) || 0,
      lineKey: el.dataset.giftLineKey || '',
      variantId: el.dataset.giftVariant || '',
      el: el
    };
  }

  // Gift-Line per item.key entfernen, danach rendert cart:refresh den Drawer neu
  function removeLine(lineKey) {
    inFlight = true;
    fetch(theme.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    })
      .catch(function (error) {
        console.error('[cart-gift-brush] remove failed', error);
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      });
  }

  function addBrush(link) {
    var variantId = link.dataset.giftVariant;
    var giftProperty = window.theme && theme.settings && theme.settings.shark_offer_property_gift;
    if (!variantId || !giftProperty || inFlight) return;

    var row = link.closest('.cart-free-gift');
    if (row) row.classList.add('is-loading');
    inFlight = true;
    setDismissed(false);

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('properties[_shark_offer]', giftProperty);

    fetch(theme.routes.cart_add_url + '?bundle_shark=true', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'Gift add failed');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:item-added', {
          detail: { product: data.items ? data.items[0] : data }
        }));
      })
      .catch(function (error) {
        console.error('[cart-gift-brush] add failed', error);
        if (row) row.classList.remove('is-loading');
        inFlight = false;
      });
  }

  // Cart-Zustand mit den Regeln abgleichen; laeuft nach jedem Re-Render des Drawers.
  function reconcile() {
    var state = readState();
    if (!state) { lastStateEl = null; inFlight = false; return; }
    // Nur ein frisch gerenderter Drawer zaehlt; andere DOM-Aenderungen (Animationen,
    // Upsell-Slider) duerfen denselben Stand nicht noch einmal auswerten
    if (state.el === lastStateEl) return;
    lastStateEl = state.el;
    // Vorheriger eigener Request ist durch (Drawer wurde neu gerendert): Guard freigeben
    inFlight = false;

    if (!state.lineKey) { autoRemoveAttempts = 0; return; }
    if (autoRemoveAttempts >= MAX_AUTO_REMOVE) return;
    if (state.count < state.threshold) {
      // Unter der Schwelle: Buerste raus, Abwahl-Merker zuruecksetzen
      setDismissed(false);
      autoRemoveAttempts++;
      removeLine(state.lineKey);
    } else if (isDismissed()) {
      // Buerste abgewaehlt, kam aber wieder (z. B. App-Auto-Add auf der Produktseite)
      autoRemoveAttempts++;
      removeLine(state.lineKey);
    }
  }

  function scheduleReconcile() {
    clearTimeout(timer);
    timer = setTimeout(reconcile, 50);
  }

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('.cart-free-gift__remove');
    if (remove) {
      // Entfernen uebernimmt app.js (.remove-Listener), hier nur merken
      setDismissed(true);
      inFlight = true;
      return;
    }
    var add = event.target.closest('.cart-free-gift__add');
    if (add) {
      event.preventDefault();
      addBrush(add);
    }
  }, true);

  function init() {
    var drawer = getDrawer();
    if (!drawer) return;
    new MutationObserver(scheduleReconcile).observe(drawer, { childList: true, subtree: true });
    scheduleReconcile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
